/*
 * Heritage Olive desktop navigation (sections/header.liquid, markup classes ho-nav* and ho-panel*).
 *
 * - The word in the nav row is a normal link: it always navigates.
 * - The small square beside it (.ho-nav__toggle) opens and closes that item's panel. A click toggles;
 *   on a mouse, hovering the item for 120ms also opens it (closes 180ms after the pointer leaves,
 *   unless the panel was opened by a click or the keyboard, which keeps it open until it is dismissed).
 * - Escape, a click outside, tabbing out, scrolling the header away and resizing below the desktop
 *   breakpoint all close it. Only one panel is open at a time.
 * - Listeners are delegated on the document, so the panels keep working after the theme editor
 *   re-renders the header section (shopify:section:load).
 */
;(function () {
	if (window.__hoNavBound) return
	window.__hoNavBound = true

	const OPEN_DELAY = 120
	const CLOSE_DELAY = 180
	const DESKTOP = '(min-width: 990px)'
	const HOVER_CAPABLE = '(hover: hover) and (pointer: fine)'

	let openTimer = null
	let closeTimer = null

	const isDesktop = () => window.matchMedia(DESKTOP).matches
	const canHover = () => window.matchMedia(HOVER_CAPABLE).matches
	const itemsWithPanel = () => document.querySelectorAll('.ho-nav__item.has-panel')
	const itemOf = (node) =>
		node && node.closest ? node.closest('.ho-nav__item.has-panel') : null
	const panelOf = (item) => item.querySelector('.ho-panel')
	const toggleOf = (item) => item.querySelector('.ho-nav__toggle')
	const isOpen = (item) => item.classList.contains('is-open')

	const clearTimers = () => {
		clearTimeout(openTimer)
		clearTimeout(closeTimer)
		openTimer = null
		closeTimer = null
	}

	const setOpen = (item, open, how) => {
		const panel = panelOf(item)
		const toggle = toggleOf(item)
		if (!panel || !toggle) return
		if (open) {
			itemsWithPanel().forEach((other) => {
				if (other !== item) setOpen(other, false)
			})
			panel.hidden = false
			item.classList.add('is-open')
			item.dataset.hoOpenBy = how || 'click'
			toggle.setAttribute('aria-expanded', 'true')
		} else {
			panel.hidden = true
			item.classList.remove('is-open')
			delete item.dataset.hoOpenBy
			toggle.setAttribute('aria-expanded', 'false')
		}
	}

	const closeAll = (returnFocusTo) => {
		clearTimers()
		itemsWithPanel().forEach((item) => {
			const hadFocusInside = item.contains(document.activeElement)
			if (isOpen(item)) setOpen(item, false)
			if (returnFocusTo && hadFocusInside) {
				const toggle = toggleOf(item)
				toggle && toggle.focus()
			}
		})
	}

	// Click: the square toggles; clicking it on a panel that opened by hover keeps it open (pins it).
	document.addEventListener('click', (event) => {
		const toggle = event.target.closest && event.target.closest('.ho-nav__toggle')
		if (toggle) {
			const item = itemOf(toggle)
			if (!item) return
			event.preventDefault()
			clearTimers()
			if (isOpen(item) && item.dataset.hoOpenBy === 'hover') {
				item.dataset.hoOpenBy = 'click'
			} else {
				setOpen(item, !isOpen(item), 'click')
			}
			return
		}
		// a click outside every open item closes the panels
		const inside = itemOf(event.target)
		itemsWithPanel().forEach((item) => {
			if (item !== inside && isOpen(item)) setOpen(item, false)
		})
	})

	// Hover (mouse only): open after a short delay, close shortly after leaving
	document.addEventListener('mouseover', (event) => {
		if (!isDesktop() || !canHover()) return
		const item = itemOf(event.target)
		if (!item) {
			// pointer is over the nav row but not on an item with a panel (or elsewhere): let a pending close run
			return
		}
		clearTimeout(closeTimer)
		if (isOpen(item)) return
		clearTimeout(openTimer)
		openTimer = setTimeout(() => setOpen(item, true, 'hover'), OPEN_DELAY)
	})
	document.addEventListener('mouseout', (event) => {
		if (!isDesktop() || !canHover()) return
		const item = itemOf(event.target)
		if (!item) return
		const to = event.relatedTarget
		if (to && item.contains(to)) return
		clearTimeout(openTimer)
		if (isOpen(item) && item.dataset.hoOpenBy === 'hover') {
			clearTimeout(closeTimer)
			closeTimer = setTimeout(() => setOpen(item, false), CLOSE_DELAY)
		}
	})

	// Keyboard
	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') return
		const anyOpen = Array.from(itemsWithPanel()).some(isOpen)
		if (!anyOpen) return
		closeAll(true)
	})
	document.addEventListener('focusin', (event) => {
		const focused = itemOf(event.target)
		itemsWithPanel().forEach((item) => {
			if (item !== focused && isOpen(item)) setOpen(item, false)
		})
	})

	// Other ways a panel should go away
	document.addEventListener('ho:close-panels', () => closeAll())
	document.addEventListener('shopify:section:load', () => closeAll())
	document.addEventListener('shopify:section:unload', () => closeAll())
	window.addEventListener('resize', () => {
		if (!isDesktop()) closeAll()
	})
	let lastScrollY = window.scrollY
	window.addEventListener(
		'scroll',
		() => {
			if (Math.abs(window.scrollY - lastScrollY) < 40) return
			lastScrollY = window.scrollY
			const anyOpen = Array.from(itemsWithPanel()).some(isOpen)
			if (anyOpen) closeAll()
		},
		{ passive: true }
	)
})()
